<template>
	<div class="library__list">
		<div class="electronic-lecture" v-for="(item, index) of dataHandle" :key="index">
			<div
				v-if="(item.listBookPageLinks && item.listBookPageLinks.length > 0) || (item.listBookLessonPlans && item.listBookLessonPlans.length > 0) || (item.lstActiveLearning && item.lstActiveLearning.length > 0)"
				class="electronic-lecture__head display-flex-center justify-content-between"
			>
				<h2 class="primary-color-txt font-size-24 font-sanpro-semibold"> {{item.name}}</h2>
				<router-link 
					v-if="item && item.listBookPageLinks"
					:to="{name: 'LibraryAll', params: {type: item.documentTypeId ? typePageLink : typeLesson, id: item.documentTypeId ? item.documentTypeId : item.bookLessonPlanTypeId, classId: parseInt(paramSearchLessons.classId) }}"
					class="primary-color font-family-Semibold font-size-16"
				>
					Xem tất cả
				</router-link>
				<router-link 
					v-else-if="item && item.listBookLessonPlans"
					:to="{name: 'LibraryAll', params: {type: item.documentTypeId ? typePageLink : typeLesson, id: item.documentTypeId ? item.documentTypeId : item.bookLessonPlanTypeId, classId: parseInt(paramSearchLessons.classId) }}"
					class="primary-color font-family-Semibold font-size-16"
				>
					Xem tất cả
				</router-link>
				<router-link 
					v-else
					:to="{name: 'LibraryAll', params: {type: typeActiveLearning, id: item.documentTypeId ? item.documentTypeId : 1, classId: parseInt(paramSearchLessons.classId) }}"
					class="primary-color font-family-Semibold font-size-16"
				>
					Xem tất cả 
				</router-link>
			</div>
			<div
				v-if="(item.listBookPageLinks && item.listBookPageLinks.length > 0) || (item.listBookLessonPlans && item.listBookLessonPlans.length > 0) || (item.lstActiveLearning && item.lstActiveLearning.length > 0)"
				class="electronic-lecture__body position-rel"
			>
				<swiper 
					:options="{slidesPerView: 4, spaceBetween: 20, slidesPerColumn: 2, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {1199: {slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 30 }, 767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.lib__next_${index}`, prevEl: `.lib__prev_${index}`}}"
					:ref="`swiper_lib_${item.bookLessonPlanTypeId ? 2 : 1}_${index}`"
					@slideNextTransitionEnd="handleNextLibs(item, index, item.bookLessonPlanTypeId ? 2 : 1)"
				>
					<swiperSlide v-for="(file, pos) of (item.bookLessonPlanTypeId ? item.listBookLessonPlans : item.listBookPageLinks ? item.listBookPageLinks : item.lstActiveLearning)" :key="pos">
            <ItemLibrary v-if="file" :dataSource="file" :isLesson="parseInt(routerQuery.tab)" :isPlay="true" :position="pos" />
					</swiperSlide>
				</swiper>
				<div v-if="(item.listBookPageLinks && item.listBookPageLinks.length > 0) || (item.listBookLessonPlans && item.listBookLessonPlans.length > 0) || (item.lstActiveLearning && item.lstActiveLearning.length > 0)" class="swiper-button-prev lib__btn__slider lib__prev" :class="`lib__prev_${index}`" slot="button-prev"></div>
				<div v-if="(item.listBookPageLinks && item.listBookPageLinks.length > 0) || (item.listBookLessonPlans && item.listBookLessonPlans.length > 0) || (item.lstActiveLearning && item.lstActiveLearning.length > 0)" class="swiper-button-next text-right lib__btn__slider lib__next" :class="`lib__next_${index}`" slot="button-next"></div>
				<p v-if="(!item.listBookPageLinks || item.listBookPageLinks.length === 0) && (!item.listBookLessonPlans || item.listBookLessonPlans.length === 0) && (!item.lstActiveLearning || item.lstActiveLearning.length === 0)" class="empty-content font-size-20 secondary-color-txt text-center">Dữ liệu đang cập nhật!</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { STORE_KEY, LESSON_PLAN_TYPE, TYPE_PAGE_LINK_LOAD, TYPE_LESSON_LOAD, TYPE_ACTIVE_LEARN_LOAD, TAB_MEDIA_PAGE_LINK, TAB_LESSON, TAB_ACTIVE_LEARNING } from './../../_store/constants'
	import { mapState, mapActions } from 'vuex'
	// import { generateThumbnailFromVideo } from '@/helpers/functions';
	// import { APP_CONFIG } from '@/utils/constants';
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'

	export default {
		name: 'SectionListItem',
		props: {
			dataSource: Array,
			bookLessonPlanTypeId: Number
		},
		components: {
      swiper, 
      swiperSlide,
			ItemLibrary: () => import('./ItemLibrary.vue')
		},
		computed: {
			routerQuery() {
				return this.$route.query;
			},
      ...mapState('common', ['loading']),
      ...mapState(STORE_KEY, ['paramSearchLessons']),
		},
		data () {
			return {
				planLessonType: LESSON_PLAN_TYPE,
				typeLesson: TYPE_LESSON_LOAD,
				typePageLink: TYPE_PAGE_LINK_LOAD,
				typeActiveLearning: TYPE_ACTIVE_LEARN_LOAD,
				tabPagelink: TAB_MEDIA_PAGE_LINK,
				tabLesson: TAB_LESSON,
				tabActiveLearning: TAB_ACTIVE_LEARNING,
				dataHandle: [],
				limitItem: 12,
				isFirstNextSlide2:true,
				isFirstNextSlide1:true
			}
		},
		watch: {
			// 'dataSource': 'initSettingData'
      'dataSource': 'setDataForLibList'
		},
		created() {
			// this.initSettingData();
      this.setDataForLibList();
		},
		methods: {
			...mapActions('common', ['setLoading']),
      ...mapActions(STORE_KEY, ["setParamSearchLesson"]),

			async initSettingData() {
				let dataLoaded = JSON.stringify(this.dataSource);
        await this.setDataForLibList(JSON.parse(dataLoaded))
				// this.dataHandle = JSON.parse(dataLoaded);
        // console.log('Init setting: ', this.dataHandle);
				// this.dataHandle.map((parent, index) => {
				// 	if(parent.listBookLessonPlans && parent.listBookLessonPlans.length > this.limitItem) {
				// 		parent['totalItems'] = parent.listBookLessonPlans.length;
				// 		// parent.listBookLessonPlans.length = this.limitItem;
				// 	} else if (parent.listBookPageLinks && parent.listBookPageLinks.length > this.limitItem) {
				// 		parent['totalItems'] = parent.listBookPageLinks.length;
				// 		// parent.listBookPageLinks.length = this.limitItem;
				// 	}
				// })
			},

      setDataForLibList () {
        let self = this
        if (self.dataSource && self.dataSource.length === 1) {
	        let indexData = self.dataHandle.findIndex(lib => self.dataSource[0].documentTypeId ? lib.documentTypeId === self.dataSource[0].documentTypeId : lib.bookLessonPlanTypeId === self.dataSource[0].bookLessonPlanTypeId)
					if (indexData === -1) {
						return
					}
					if (self.dataSource[0].documentTypeId) {
						self.dataHandle[indexData] = {...self.dataSource[0], listBookPageLinks: [...self.dataHandle[indexData].listBookPageLinks, ...self.dataSource[0].listBookPageLinks]}
					} else if(self.dataSource[0].bookLessonPlanTypeId){
						self.dataHandle[indexData] = {... self.dataSource[0], listBookLessonPlans: [...self.dataHandle[indexData].listBookLessonPlans, ...self.dataSource[0].listBookLessonPlans] }
					} else if(self.dataSource[0].activeLearningId){
						self.dataHandle[indexData] = {... self.dataSource[0], lstActiveLearning: [...self.dataHandle[indexData].lstActiveLearning, ...self.dataSource[0].lstActiveLearning] }
					}
        } else {
    		  self.dataHandle = self.dataSource
        }
      },

      handleNextLibs (item, index, type) {
		  	// console.log('vao day nao bae', item);
		if(this.isFirstNextSlide2 && item.bookLessonPlanTypeId == 2){
			 this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: item.bookLessonPlanTypeId, pageIndex: item.paging.pageIndex + 1, documentTypeId: 0 });
			 this.isFirstNextSlide2 = false
		}
		if(this.isFirstNextSlide1 && item.bookLessonPlanTypeId == 1){
			 this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: item.bookLessonPlanTypeId, pageIndex: item.paging.pageIndex + 1, documentTypeId: 0 });
			 this.isFirstNextSlide1 = false
		}
        const swiperRef = this.$refs[`swiper_lib_${type}_${index}`][0].swiper;
        if(swiperRef && swiperRef.isEnd && item.paging && item.paging.pageIndex < item.paging.totalPage && !this.loading) {
          if (item.bookLessonPlanTypeId) {
            this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: item.bookLessonPlanTypeId, pageIndex: item.paging.pageIndex + 1, documentTypeId: 0 });
			
          } else if (item.documentTypeId) {
            this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: 0, pageIndex: item.paging.pageIndex + 1, documentTypeId: item.documentTypeId });
          } else  {
			//   if (item && item.lstActiveLearning && item.lstActiveLearning[0].activeLearningId)
            this.setParamSearchLesson({...this.paramSearchLessons, pageIndex: item.paging.pageIndex + 1, documentTypeId: 0 });
          }
        }
      }
			// viewMoreLibs(index) {
			// 	this.setLoading(true);
			// 	let lengthDataItems = this.dataHandle[index].listBookLessonPlans ? this.dataHandle[index].listBookLessonPlans.length : this.dataHandle[index].listBookPageLinks.length;
			// 	if(this.dataHandle[index].listBookLessonPlans) {
			// 		this.dataHandle[index].listBookLessonPlans = this.dataSource[index].listBookLessonPlans.slice(0, lengthDataItems + (this.limitItem * 2));
			// 	} else if (this.dataHandle[index].listBookPageLinks) {
			// 		this.dataHandle[index].listBookPageLinks = this.dataSource[index].listBookPageLinks.slice(0, lengthDataItems + (this.limitItem * 2));
			// 	}
			// 	this.setLoading(false);
			// }
		}
	}
</script>

<style lang="scss" scoped>
	.electronic-lecture {
		&__head {
			padding-bottom: 7px;
			border-bottom: 1px solid #d0d5d8;
			margin: 32px 0 24px 0;
		}
		&__body {
			.text-width {
				overflow: hidden;
			}
			.item-lecture {
				&:hover {
					opacity: 0.8;
				}
			}
			.title-lecture {
				padding-left: 15px;
			}
		}
	}
	
	.viewmore {
		&:hover {
			text-decoration: underline!important;
		}
	}

	.empty-content {
		margin-top: 20px;
	}

  .lib__btn__slider {
    position: absolute;
    @extend .position-center-y;
    z-index: 1;

    &.lib__prev {
      left: -8%;
    }

    &.lib__next {
      right: -8%;
    }
	}
	
	@media screen and (max-width: 991px) {
		
		.lib__btn__slider {
			&.lib__prev {
				left: -17px;
			}

			&.lib__next {
				right: -30px;
			}
		}
	}

	@media screen and (max-width: 600px) {
		.item-lecture {
			margin-top: 20px;
		}
	}
</style>
<style lang="scss">